exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wrapper__header-2f2oq5{background:#f8f9fa;position:relative;padding:15px}.header__kb-branding-31L1uJ{position:absolute;right:0}", ""]);
